import axios from 'axios'
import * as lodash from 'lodash';
import * as common from "@/common.js";
import {getDropdownItems, getDropdownItemsEmpty} from "@/spaApi";

axios.defaults.headers.common['Pragma'] = 'no-cache';

export function submitAccountToEpic(accountId, destination, postData, callback, errorCallback)  {
  let postUrl = `integrations/accounts/${accountId}/submittoepic/${destination}`;

  return axios.post(postUrl, postData).then((response) => {
    return callback(response);
  }).catch(error => {
    return errorCallback(error);
  });
}

export async function submitContactToEpic(contactId, accountId, destination, postData, callback, errorCallback){
  const postUrl = `integrations/contacts/${contactId}/submittoepic/${destination}/${accountId}`;
  try {
    const response = await axios.post(postUrl, postData);
    return { postData, response };
  } catch (error) {
    throw { postData, error };
  }
}

export function submitPolicyToEpic(accountId, opportunityId, destination, postData, policyType, callback, errorCallback){
  const postUrl =  `integrations/policies/submittoepic/${destination}/${accountId}/${opportunityId}`;
  return axios.post(postUrl, postData).then((response) => {
    return callback(policyType, response);
  }).catch(error => {
    return errorCallback(postData, error);
  });
}

export function submitUpdateCOREStatus(integrationId, status, statusMessage, dynamicsInstanceName, targetSystem, callback, errorCallback){
  const postUrl = `integrations/${integrationId}/updatestatus/${status}?dynamicsInstanceName=${dynamicsInstanceName}&destination=${targetSystem}`;
  return axios.post(postUrl, null).then((response) => {
    return callback(statusMessage, response);
  }).catch(error => {
    return errorCallback(statusMessage, error);
  });
}

export function loadEpicIntegration(integrationId, dynamicsInstanceName, callback, errorCallback){
  const url = `integrations/new/epic/${integrationId}/din/${dynamicsInstanceName}`;
  return axios.get(url).then((response) => {
    return callback(response);
  }).catch(error => {
    return errorCallback(error);
  });
}

export function getEpicAccountById(epicPK, destination, callback, errorCallback){
  const url = `echos/accounts?clientId=${epicPK}&epicDestination=${destination}`;
  return axios.get(url).then((response) => {
    return callback(epicPK, response);
  }).catch(error => {
    return errorCallback(error);
  });
}

export function epicAccountSearch(zip, agency, name, destination, pagenumber){
  const url = `echos/accounts?zipcode=${zip}&agencyCode=${agency}&accountName=${encodeURIComponent(name)}&epicDestination=${destination}&pageNumber=${pagenumber}`;
  return axios.get(url).then(async (response) => {
    return(response);
  }).catch(error => {
    return(error);
  });
}

export function epicAccountSearchByAgencies(payload) {
  return axios.post('echos/accounts/byagencies', payload);
}

export function triggerManualSync(payload, callback, errorCallback){
  const url = `echos/client/manual-sync`;
  return axios.post(url, payload).then((response) => {
    return callback();
  }).catch(error => {
    return errorCallback(error);
  });
}

export function getEpicContactsByAccountId(accountId, destination, callback, errorCallback){
  const url = `echos/contacts?accountID=${accountId}&epicDestination=${destination}`;
  return axios.get(url).then((response) => {
    return callback(response);
  }).catch(error => {
    return errorCallback(error);
  });
}

export function getEpicPolicyDefaults(dynamicsInstanceName, businessUnitName, callback, errorCallback){
  const url = `defaults/policy-defaults/${dynamicsInstanceName}/${businessUnitName}`;
  return axios.get(url).then((response) => {
    return callback(response);
  }).catch(error => {
    return errorCallback(error);
  });
}

export function getEpicLineTypes(epicDestination, policyType, callback, errorCallback) {
  const url = `echos/line-types?epicDestination=${encodeURIComponent(epicDestination)}&policyType=${encodeURIComponent(policyType)}`;
  return axios.get(url).then(response => {
    return callback(response.data);
  }).catch(error => {
    return errorCallback(error);
  });
}

export function getDynamicsContactByEpicKey(destination, epicPk, dynamicsInstanceName, callBack){
  axios.get(`dynamics/${dynamicsInstanceName}/contact/epic/${destination}/${epicPk}`).then(res => {
    callBack(res.data);
  }).catch(error => {
    console.log(error);
  });
}

export function getDynamicsContactByEpicAccountId(destination, epicPk, dynamicsInstanceName, callBack){
  axios.get(`dynamics/${dynamicsInstanceName}/contact/epic/${destination}/account/${epicPk}`).then(res => {
    callBack(res.data);
  }).catch(error => {
    console.log(error);
  });
}

export function getDynamicsAccountByEpicKey(destination, epicPk, dynamicsInstanceName, callBack){
  axios.get(`dynamics/${dynamicsInstanceName}/account/epic/${destination}/${epicPk}`).then(res => {
    callBack(res.data);
  }).catch(error => {
    console.log(error);
  });
}


export function getEpicSicCodes(loading, userSearch, currentSicCode, epicDestination, dropdownDataGetSetCallBack) {
  let url = `echos/sic-codes?searchTerm=${escape(userSearch)}&epicDestination=${epicDestination}`
  getDropdownItems(loading, url, currentSicCode, dropdownDataGetSetCallBack);
}

export function getEpicNaicsCodes(loading, userSearch, currentNaicsCode, epicDestination, dropdownDataGetSetCallBack) {
  let url = `echos/naics-codes?searchTerm=${escape(userSearch)}&epicDestination=${epicDestination}`
  getDropdownItems(loading, url, currentNaicsCode, dropdownDataGetSetCallBack);
}

export function getEpicAccountProducers(loading, userSearch, currentBrokerId, epicDestination, dropdownDataGetSetCallBack) {
  let url = `echos/producers/account?searchTerm=${userSearch}&epicDestination=${epicDestination}`;
  getDropdownItems(loading, url, currentBrokerId, dropdownDataGetSetCallBack);
}

export function getDynamicsLinksByEpicAccountId(destination, epicPk, dynamicsInstanceName, callBack){
  axios.get(`dynamics/${dynamicsInstanceName}/links/epic/${destination}/${epicPk}`).then(res => {
    callBack(res.data);
  }).catch(error => {
    console.log(error);
  });
}

export function getEpicPolicyProducers(loading, userSearch, currentBrokerId, epicDestination, dropdownDataGetSetCallBack, businessUnitName, dynamicsInstanceName) {
  let url = `echos/producers/policy?searchTerm=${userSearch}&epicDestination=${epicDestination}&businessUnitName=${businessUnitName}&dynamicsInstanceName=${dynamicsInstanceName}`;
  getDropdownItems(loading, url, currentBrokerId, dropdownDataGetSetCallBack);
}

export function getEpicPolicyProducer(producerId, producerName, epicDestination, businessUnitName, dynamicsInstanceName, callback) {
  const searchTerm = encodeURIComponent(producerName || producerId);
  const url = `echos/producers/policy?searchTerm=${searchTerm}&epicDestination=${epicDestination}&businessUnitName=${businessUnitName}&dynamicsInstanceName=${dynamicsInstanceName}`;

  return axios.get(url).then(response => {
    const producer = response.data.find(item => item.id === producerId) || null;
    callback(producerId, producer);
  }).catch(error => {
    console.log(error);
    callback(producerId, null);
  });
}

export function getEpicAccountServicers(loading, userSearch, currentBrokerId, epicDestination, dropdownDataGetSetCallBack) {
  let url = `echos/servicers/account?searchTerm=${userSearch}&epicDestination=${epicDestination}`;
  getDropdownItems(loading, url, currentBrokerId, dropdownDataGetSetCallBack);
}

export function getEpicPolicyServicers(loading, userSearch, currentBrokerId, epicDestination, dropdownDataGetSetCallBack) {
  let url = `echos/servicers/policy?searchTerm=${userSearch}&epicDestination=${epicDestination}`;
  getDropdownItems(loading, url, currentBrokerId, dropdownDataGetSetCallBack);
}

export function getCountryStatesEPIC(countryName, epicDestination, dropdownDatSetCallBack) {
  let global = common.Singleton.getInstance();
  let statesForCountry = null;

  if (global.EPICstates) {
    statesForCountry = global.EPICstates.find(x => x.name == countryName);
  }
  else {
    global.EPICstates = new Array();
  }

  if (statesForCountry) {
    dropdownDatSetCallBack(statesForCountry.data); //set
  }
  else {

    axios.get(`echos/states?countryCode=${countryName}&epicDestination=${epicDestination}`).then(res => {
      global.EPICstates.push({ name: countryName, data: res.data });
      dropdownDatSetCallBack(res.data); //set
    }).catch(error => {
      console.log(error); //what else?
    });
  }
}


export function getEpicIssuingCompanies(loading, userSearch, currentCompanyId, epicDestination, dropdownDataGetSetCallBack, agencyId, branchId, departmentId, profitCenterId) {
  let url = `echos/issuing-companies?searchTerm=${userSearch}&epicDestination=${epicDestination}&agencyId=${agencyId}&branchId=${branchId}&departmentId=${departmentId}&profitCenterId=${profitCenterId}`;
  if (agencyId && branchId && departmentId && profitCenterId) {
    getDropdownItems(loading, url, currentCompanyId, dropdownDataGetSetCallBack);
  } else {
    getDropdownItemsEmpty(loading, url, currentCompanyId, dropdownDataGetSetCallBack);
  }
}

export function getPolicyNumberFormat(issuingCompanyCode, policyType, regexGetSetCallBack) {
  axios.get(`echos/policy-number-format/${escape(issuingCompanyCode)}/${policyType}`).then(res => {
    regexGetSetCallBack(res.data); //set
  }).catch(error => {
    console.log(error); //what else?
  });
}

export function updateHousehold(dynamicsHouseholdId, destination, accountId, dynamicsInstanceName) {
  const postUrl = `integrations/household/${dynamicsInstanceName}/${dynamicsHouseholdId}/${destination}/${accountId}`;
  return axios.put(postUrl).then((response) => {
    return (response);
  }).catch(error => {
    console.log(error);
  });
}
